import { ICON_CALENDAR, ICON_CONTRACTS } from "common/constants";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import * as moment from "moment";

const IndividualItem = ({ data, index }: { data: any; index: number }) => {
  const detailsString = useMemo(() => {
    const details = [
      data.gender && `Gender: ${data.gender}`,
      data.emailAddress && `Email: ${data.emailAddress}`,
      data.phoneNumber && `Phone Number: ${data.phoneNumber}`,
      data.passportOrIdNumber &&
        `Passport or Id Number: ${data.passportOrIdNumber}`,
      data?.payments?.length > 0 &&
        `Positions : ${data.payments
          .map((payment: any) => payment.positionTitle)
          .join(", ")}`,
    ].filter(Boolean);

    return details.join(", ");
  }, [
    data.emailAddress,
    data.gender,
    data.passportOrIdNumber,
    data.payments,
    data.phoneNumber,
  ]);

  const paymentCount = data?.payments?.length || 0;

  return (
    <div className={index === 0 ? "pb-3" : "py-3"}>
      <h5 className="mb-1">
        <Link to={`/individuals/${data?.id}`}>{data?.fullName || ""}</Link>
      </h5>
      <p className="text-secondary mb-2">
        <span className="me-2 text-capitalize fw-semibold">Individual</span>

        {/* <span className="badge bg-success-subtle text-success fs-11 me-2">
          1 Active Contract
        </span> */}
      </p>
      <p className="text-muted mb-2">{`... ${detailsString} ...
      `}</p>
      <ul className="list-inline d-flex align-items-center g-3 text-muted fs-14 mb-0">
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CALENDAR}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">
                Last Updated:{" "}
                {moment(new Date(data?.updatedAt)).format("DD MMM Y")}
              </span>
            </div>
          </div>
        </li>
        <li className="list-inline-item">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0">
              <i className={ICON_CONTRACTS}></i>
            </div>
            <div className="flex-grow-1 fs-13 ms-1">
              <span className="fw-medium">{`${paymentCount} Contract${
                paymentCount !== 1 ? "s" : ""
              }`}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default IndividualItem;
